import { IResponderPesquisaSatisfacaoLink } from "../../../Interfaces/Geral/ResponderFormularioLink/ResponderFormularioLinkInterface";
import {
    BuscarContaLinkService,
    ListarFormularioPerguntaRespostasService,
    ResponderPesquisaSatisfacaoLinkService,
} from "../../../Services/Geral/ResponderFormularioLink/ResponderFormularioLinkService";
import { Controller } from "../../Controller";

export async function BuscarContaLinkController(
    guid: string,
    idOrganizacao: string
) {
    return Controller(BuscarContaLinkService(guid, idOrganizacao));
}

export async function ListarFormularioPerguntaRespostasController(
    idFormulario: string,
    idOrganizacao: string
) {
    return Controller(
        ListarFormularioPerguntaRespostasService(idFormulario, idOrganizacao)
    );
}

export async function ResponderPesquisaSatisfacaoLinkController(
    idCaso: number,
    guid: string,
    idOrganizacao: string,
    data: IResponderPesquisaSatisfacaoLink
) {
    return Controller(
        ResponderPesquisaSatisfacaoLinkService(
            idCaso,
            guid,
            idOrganizacao,
            data
        )
    );
}
